import cx from "classnames";
import { Plugin } from "prosemirror-state";
import { Decoration, DecorationSet } from "prosemirror-view";

import { Extension } from "../extension";
import { expandSelectionToBlocks } from "../utils";

class SelectedBlock extends Extension {
	get name() {
		return "selected-block";
	}
	get plugins() {
		const selectedBlockPlugin = new Plugin({
			props: {
				decorations: state => {
					const view = this.editorView;
					if (!view) return null;
					if (view.dragging) return null;
					let decos: Decoration[] = [];
					const {
						selection: { from, to, head },
						doc,
					} = state;
					const [start, end] = expandSelectionToBlocks(from, to, doc);
					doc.nodesBetween(start, end, (node, pos) => {
						const focusWithIn = pos < head && pos + node.nodeSize > head;
						decos.push(
							Decoration.node(pos, pos + node.nodeSize, {
								class: cx("prose-selected-block", { "prose-focused-block": focusWithIn }),
							}),
						);
						return false;
					});
					return DecorationSet.create(doc, decos);
				},
			},
		});
		return [selectedBlockPlugin];
	}
}

export default SelectedBlock;
